import React from 'react';

const BreadcrumbItem = ({ children, ...props }) => (
  <li className="breadcrumb-item" {...props} aria-label="Breadcumb">
    {children}
  </li>
);

const Breadcrumb = props => {
  let children = React.Children.toArray(props.children);

  children = children.map((child, index) => {
    if (index === children.length - 1) {
      const isAnchor = child.type === 'a';
      if (!isAnchor) {
        child = (
          <a href="" aria-current="page">
            {child}
          </a>
        );
      }
    }

    const liProps =
      index === children.length - 1
        ? {}
        : props.ariaLabel && index === children.length - 1
        ? { 'aria-current': true }
        : {};

    return (
      <BreadcrumbItem {...liProps} key={`breadcrumb_item${index}`}>
        {index !== 0 && (
          <span className="breadcrumb-separator" aria-hidden="true">
            &gt;
          </span>
        )}
        {child}
      </BreadcrumbItem>
    );
  });

  return (
    <nav
      className="mainBreadcrumb"
      role="navigation"
      aria-label={props.ariaLabel ? props.ariaLabel : 'Breadcrumb'}
    >
      <ul>{children}</ul>
    </nav>
  );
};

export default Breadcrumb;
